module.exports = __webpack_public_path__ + "media/images/qr/square-b960edc107a7b98124519969eda43c74.png";